import React, { Component } from 'react';
import FacebookLogin from 'react-facebook-login/dist/facebook-login-render-props';
import GoogleLogin from 'react-google-login';
import ZSClient from '../components/Zalo';
import axios from 'axios';
import { withRouter } from 'react-router-dom';
import MyContext from '../common/MyContext'
import { withTranslation } from 'react-i18next';
import "../assets/css/login.css";
import { setCookie } from '../common/cookie.js';
import { detectApp, detectMob } from '../common/utils.js';
import { applyAuthToken } from '../common/authToken.js';
import { toast } from 'react-toastify';
import { isAdminPortalHostname } from '../common/homeUrlByHost.js';

const $ = window.$;

class LoginDialog extends Component {
  constructor(props) {
    super(props)

    this.handleResponse = this.handleResponse.bind(this);
    this.handleError = this.handleError.bind(this);
    this.uidLoginSuccess = this.uidLoginSuccess.bind(this);
    this.handleUidLogin = this.handleUidLogin.bind(this);
    this.handleUidChange = this.handleUidChange.bind(this);
    this.handlePasswordChange = this.handlePasswordChange.bind(this);
    this.handleShowUidForm = this.handleShowUidForm.bind(this);
    this.handleBack = this.handleBack.bind(this);

    this.state = {
      uid: '',
      password: '',
      showUidForm: false
    };
  }

  componentDidMount() {
    // this.facebookInitialize();
    // const auth = getAuth();
    // window.recaptchaVerifier = new RecaptchaVerifier('recaptcha-container', {}, auth);

    // Khởi tạo SDK LaoID khi component đã được mount
    if (window.LaoIdSSO) {
      window.LaoIdSSO.init(
        'ea4907b5-dce9-4eaf-a31d-d20e5d30560d',
        'https://wap.okara.la/login/uniid-callback',
        true
      );
    }
  }

  handleResponse = (data) => {

    $("#loginDialog").modal("hide");

    let self = this;
    // if (data.tokenDetail != null && data.tokenDetail.accessToken != null) {
    if (data.accessToken != null) {
      console.log(data)
      // const json = JSON.stringify({ domain: window.location.hostname, accessToken: data.tokenDetail.accessToken });
      const json = JSON.stringify({ domain: window.location.hostname, accessToken: data.accessToken });

      axios.post(global.config.apiDomain + '/rest/loginuser/login', json, {
        headers: {
          'Content-Type': 'application/json'
        }
      }).then(res => {
        console.log("login")
        const { user, role, token } = res.data;
        if (user != null) {
          user.role = role;
          applyAuthToken(token);
          if (detectApp("tl.okara") || detectApp("localhost") || detectApp("mz.okara") || detectApp("ht.okara")) {
            if (user.phoneNumber == null) {
              self.context.updateUserTemp(user);
              $("#modalPhoneVetification").modal("show");
              return;
            }
          }
          const { history } = self.props;
          window.localStorage.setItem("login", true);
          window.localStorage.setItem("userId", user.facebookId);
          window.localStorage.setItem("profileImageLink", user.profileImageLink);
          window.localStorage.setItem("name", user.name);
          setCookie("login", "true", 1);
          setCookie("userId", user.facebookId, 1);
          setCookie("profileImageLink", user.profileImageLink, 1);
          setCookie("name", user.name, 1);

          if (history) {
            if (history.action == "PUSH") {
              history.goBack();
            } else {
              history.push('/');
            }
            self.context.updateUser(user);
          }
        }
      })
    }
  }

  handleError = (error) => {
    $("#loginDialog").modal("hide");

    this.setState({ error });
    console.log(error)
  }


  googleSuccess = (data) => {
    const email = data?.profileObj?.email?.toLowerCase?.() || '';

    if (!email) {
      toast.warning('Không lấy được email từ tài khoản Google');
      return;
    }

    // Không chặn cứng theo domain ở FE nữa: server còn cho phép whitelist email
    // lẻ ngoài domain công ty (/rest/login-whitelist). Chặn ở đây sẽ khiến các
    // email đã được cấp quyền không đăng nhập được. Quyết định cuối cùng thuộc
    // về server - FE chỉ hiển thị thông báo khi bị từ chối.

    $("#loginDialog").modal("hide");

    const json = JSON.stringify({ domain: window.location.hostname, accessToken: data.tokenId });

    axios.post(global.config.apiDomain + '/rest/loginuser/loginGoogle', json, {
      headers: {
        'Content-Type': 'application/json'
      }
    }).then(res => {
      console.log("login")
      // role nằm ở cấp ngoài của response, không nằm trong user -> phải gộp vào
      // trước khi đẩy lên context, nếu không Menu đọc user.role = undefined và
      // ẩn lối vào trang quản lý cho tới khi user F5 lại trang.
      const { user, role, token } = res.data;
      if (user == null) {
        // Server trả user rỗng khi email không thuộc domain công ty và không nằm
        // trong whitelist (hoặc token không hợp lệ).
        toast.warning('Tài khoản này không có quyền đăng nhập web quản trị');
        return;
      }
      user.role = role;

      applyAuthToken(token);
      if (detectApp("tl.okara") || detectApp("localhost") || detectApp("mz.okara") || detectApp("ht.okara")) {
        if (user.phoneNumber == null) {
          this.context.updateUserTemp(user);
          $("#modalPhoneVetification").modal("show");
          return;
        }
      }

      const { history } = this.props;
      window.localStorage.setItem("login", true);
      window.localStorage.setItem("userId", user.facebookId);
      window.localStorage.setItem("profileImageLink", user.profileImageLink);
      window.localStorage.setItem("name", user.name);
      setCookie("login", "true", 1);
      setCookie("userId", user.facebookId, 1);
      setCookie("profileImageLink", user.profileImageLink, 1);
      setCookie("name", user.name, 1);

      if (history) {
        if (history.action == "PUSH") {
          history.goBack();
        } else {
          history.push('/');
        }
        this.context.updateUser(user);
      }
    })
  }

  googleFailed = (error) => {
    // Lỗi hay gặp: idpiframe_initialization_failed - origin hiện tại chưa được
    // khai trong Authorized JavaScript origins của client ID trên Google Console.
    console.error("Google login failed:", error);

    if (error && error.error === "idpiframe_initialization_failed") {
      // Lỗi init xảy ra lúc load trang, không phải do user bấm -> không đóng
      // dialog, chỉ log để biết. Nút Google đã tự disable qua renderProps.
      return;
    }

    if (error && error.error === "popup_closed_by_user") {
      return;
    }

    $("#loginDialog").modal("hide");
  }

  zaloSuccess = (code) => {
    // const json = JSON.stringify({ domain: window.location.hostname, accessToken: data.tokenDetail.accessToken });
    const json = JSON.stringify({ domain: window.location.hostname, accessToken: code });

    axios.post(global.config.apiDomain + '/rest/loginuser/loginZalo', json, {
      headers: {
        'Content-Type': 'application/json'
      }
    }).then(res => {
      console.log("login")
      const { user, role, token } = res.data;
      if (user != null) {
        user.role = role;
        applyAuthToken(token);
        const { history } = this.props;
        window.localStorage.setItem("login", true);
        window.localStorage.setItem("userId", user.facebookId);
        window.localStorage.setItem("profileImageLink", user.profileImageLink);
        window.localStorage.setItem("name", user.name);
        setCookie("login", "true", 1);
        setCookie("userId", user.facebookId, 1);
        setCookie("profileImageLink", user.profileImageLink, 1);
        setCookie("name", user.name, 1);

        if (history) {
          if (history.action == "PUSH") {
            history.goBack();
          } else {
            history.push('/');
          }
          this.context.updateUser(user);
        }

      }
      $("#loginDialog").modal("hide");
    })
  }

  handleUidChange = (e) => {
    this.setState({ uid: e.target.value });
  }

  handlePasswordChange = (e) => {
    this.setState({ password: e.target.value });
  }

  handleShowUidForm = () => {
    this.setState({ showUidForm: true });
  }

  handleBack = () => {
    this.setState({ 
      showUidForm: false,
      uid: '',
      password: ''
    });
  }

  handleUidLogin = (e) => {
    e.preventDefault();
    if (!this.state.uid || !this.state.password) {
      return;
    }
    this.uidLoginSuccess();
  }

  uidLoginSuccess = () => {
    $("#loginDialog").modal("hide");

    const json = JSON.stringify({ 
      domain: window.location.hostname, 
      uid: this.state.uid,
      password: this.state.password
    });

    axios.post(global.config.apiDomain + '/rest/loginuser/login-with-uid', json, {
      headers: {
        'Content-Type': 'application/json'
      }
    }).then(res => {
      console.log("login")
      const { user, role, token } = res.data;
      if (user != null) {
        user.role = role;
        applyAuthToken(token);
        const { history } = this.props;
        window.localStorage.setItem("login", true);
        window.localStorage.setItem("userId", user.facebookId);
        window.localStorage.setItem("profileImageLink", user.profileImageLink);
        window.localStorage.setItem("name", user.name);
        setCookie("login", "true", 1);
        setCookie("userId", user.facebookId, 1);
        setCookie("profileImageLink", user.profileImageLink, 1);
        setCookie("name", user.name, 1);

        if (history) {
          if (history.action == "PUSH") {
            history.goBack();
          } else {
            history.push('/');
          }
          this.context.updateUser(user);
        }
        $("#loginDialog").modal("hide");
      } else {
        // Hiển thị toast khi user và role đều null
        toast.warning('Sai tài khoản hoặc mật khẩu');
        $("#loginDialog").modal("hide");
      }
    }).catch(err => {
      console.log("login error", err);
      toast.warning('Sai tài khoản hoặc mật khẩu');
      $("#loginDialog").modal("hide");
    })
  }


  facebookLoginButton(renderProps) {
    return (
      <div className="p-1">
        <button
          onClick={renderProps.onClick}
          // onClick={() => this.loginForFacebook()}
          className="btn w-100 facebook-login text-center">
          <span className="float-left login-icon">
          <img className="" src={require('../assets/images/facebook_icon.svg').default} />
          </span>
          <span className="text-white my-1">Facebook</span>
          <span className="login-icon float-right"></span>
        </button>
      </div>
    )
  }

  googleLoginButton(renderProps, label = "Google") {
    // renderProps.disabled = true khi gapi.auth2 chưa init xong (hoặc init lỗi,
    // ví dụ origin chưa đăng ký trong Authorized JavaScript origins). Phải truyền
    // xuống button, nếu không nút vẫn bấm được nhưng onClick không làm gì cả -
    // trông như "bấm không phản hồi" mà không có lỗi nào trong console.
    return (
      <div className="p-1">
        <button
          onClick={renderProps.onClick}
          disabled={renderProps.disabled}
          className="btn w-100 google-login text-center"
          style={renderProps.disabled ? { opacity: 0.5, cursor: "not-allowed" } : {}}
          title={renderProps.disabled ? "Đang khởi tạo Google Sign-In..." : ""}
        >
          <span className="float-left login-icon">
          <img src={require('../assets/images/google_icon.svg').default} />
          </span>
          <span className="my-1">{label}</span>
          <span className="login-icon float-right"></span>
        </button>
      </div>
    )
  }

  facebookInitialize() {
    const { t } = this.props;

    window.fbAsyncInit = function () {
      console.log(window.FB)
      window.FB.init({
        appId: t("commons.facebook_app_id", "370514506352628"),
        cookie: true,
        xfbml: true,
        version: 'v3.1'
      });
      window.FB.AppEvents.logPageView();
    };
    (function (d, s, id) {
      var js, fjs = d.getElementsByTagName(s)[0];
      if (d.getElementById(id)) {
        return;
      }
      js = d.createElement(s);
      js.id = id;
      js.src = 'https://connect.facebook.net/en_US/sdk.js';
      fjs.parentNode.insertBefore(js, fjs);
    }(document, 'script', 'facebook-jssdk'));
  }

  loginForFacebook() {

    $("#loginDialog").modal("hide");

    let self = this;

    window.FB.login((response) => {
      console.log('submit login', response);
      if (response.authResponse) {
        const json = JSON.stringify({ domain: window.location.hostname, accessToken: response.authResponse.accessToken });

        axios.post(global.config.apiDomain + '/rest/loginuser/login', json, {
          headers: {
            'Content-Type': 'application/json'
          }
        }).then(res => {
          console.log("login")
          const { user, role, token } = res.data;
          if (user != null) {
            user.role = role;
            applyAuthToken(token);
            const { history } = self.props;
            window.localStorage.setItem("login", true);
            window.localStorage.setItem("userId", user.facebookId);
            window.localStorage.setItem("profileImageLink", user.profileImageLink);
            window.localStorage.setItem("name", user.name);
            setCookie("login", "true", 1);
            setCookie("userId", user.facebookId, 1);
            setCookie("profileImageLink", user.profileImageLink, 1);
            setCookie("name", user.name, 1);

            if (history) {
              if (history.action == "PUSH") {
                history.goBack();
              } else {
                history.push('/');
              }
              self.context.updateUser(user);
            }
          }
        })

      } else {

      }
    });
  }

  openPhoneDialog() {
    $("#loginDialog").modal("hide");
    // $("#modalPhoneVetification").modal("show");
    $("#modalPhoneVetification").modal("show");

  }

  render() {
    const { t } = this.props;
    const pathName = window.location.pathname;
    let show = pathName != "/login/zalo-callback" && pathName != "/login/uniid-callback";
    const isLockedLogin =
      isAdminPortalHostname(window.location.hostname)
    return (
      <div
        className="modal fade"
        id="loginDialog"
        tabIndex={-1}
        role="dialog"
        aria-labelledby="exampleModalLabel"
        aria-hidden="true"
        {...(isLockedLogin ? { "data-backdrop": "static", "data-keyboard": "false" } : {})}
      >
        <div className="modal-dialog modal-dialog-centered" role="document">
          <div className="modal-content ">
            {/* <div className="modal-header"> */}
            {!isLockedLogin && (
              <button type="button" className="close d-flex justify-content-end mr-2" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">×</span>
              </button>
            )}
            {/* </div> */}
            <div className="modal-body">
              <div className="d-flex justify-content-center">
                <div className="login-logo p-3 ">
                <img src={require("../assets/images/" + t('login_dialog.logo', "yokara_icon.png")).default} />
                </div>
              </div>
              <div className="text-center p-2">
                <p style={{ "fontSize": "16px" }}>{t("login_dialog.description", "Đăng nhập hoặc đăng ký tài khoản của bạn để có trải nghiệm tốt hơn")}</p>
              </div>
              {/* tắt login facebook */}
              {/* {!this.state.showUidForm && !detectApp('lo.okara') && !detectApp('my.okara') &&
                <FacebookLogin
                  appId={t("commons.facebook_app_id", "370514506352628")}
                  autoLoad={false}
                  fields="name,email,picture"
                  isMobile={false}
                  xfbml={true}
                  version="3.1"
                  redirectUri={window.location.href}
                  disableMobileRedirect={true}
                  callback={this.handleResponse}
                  render={(renderProps) => (
                    this.facebookLoginButton(renderProps)
                  )}
                />} */}

              {!this.state.showUidForm && detectApp('ikarayokara') &&
                <GoogleLogin
                  clientId="366287804041-bmieenvk3ra7eerv8p67eiura87of7bo.apps.googleusercontent.com"
                  onSuccess={this.googleSuccess}
                  onFailure={this.googleFailed}
                  cookiePolicy={'single_host_origin'}
                  render={(renderProps) => (
                    this.googleLoginButton(renderProps)
                  )}
                ></GoogleLogin>
              }

              {/* tắt login zalo
              {!this.state.showUidForm && detectApp('ikarayokara') && <div className="p-1">
                <a href={ZSClient.getLoginUrl()} className="btn w-100 zalo-login text-center">
                  <span className="float-left login-icon">
                  <img src={require('../assets/images/zalo_icon.svg').default} />
                  </span>
                  <span className="text-white my-1">Zalo</span>
                  <span className="login-icon float-right"></span>
                </a>
              </div>} */}

              {!this.state.showUidForm && detectApp('lo.okara') && <div className="p-1">
                <a href={"https://sso.laoid.net/login?client_id=ea4907b5-dce9-4eaf-a31d-d20e5d30560d&redirect_uri=https://wap.okara.la/login/uniid-callback&use_callback_uri=true"} className="btn w-100 uniid-login text-center">
                  <span className="float-left login-icon">
                    <img className="" src={require('../assets/images/laoid_logo.png').default} />
                  </span>
                  <span className="text-white my-1">LaoID</span>
                  <span className="login-icon float-right"></span>
                </a>
              </div>}

              {!this.state.showUidForm && detectApp('ht.okara') && detectMob() != "unknown" && <div className="p-1">
                <a href={"natcom://webgamenatcom?ref=" + encodeURIComponent("https://okara.natcom.com.ht/login/natcomid-callback") + "&isFromWeb=true"} className="btn w-100 uniid-login text-center">
                  <span className="float-left login-icon">
                  <img className="mt-1" src={require('../assets/images/uniid_icon.svg').default} />
                  </span>
                  <span className="text-white my-1">NatcomID</span>
                  <span className="login-icon float-right"></span>
                </a>
              </div>}

              {/* Myanmar */}

              {!this.state.showUidForm && detectApp("my.okara") && <div className="p-1">
                <a href={"https://uid.com.la:9998/credentials/sign-in/oauth/consent?clientId=a3fe5e84-212a-4bb2-be5e-84212adbb2ac&redirectUri=" + encodeURIComponent("https://wap.okara.la/login/uniid-callback") + "&isFromWeb=true"} className="btn w-100 uniid-login text-center">                  <span className="float-left login-icon">
                <img className="mt-1" src={require('../assets/images/uniid_icon.svg').default} />
                  </span>
                  <span className="text-white my-1">UniID</span>
                  <span className="login-icon float-right"></span>
                </a>
              </div>}

              {!this.state.showUidForm && (detectApp('tl.okara') || detectApp('mz.okara') || detectApp('localhost') || detectApp('ht.okara')) && ( 
                <div className="p-1">
                  <a
                    onClick={this.openPhoneDialog}
                    className="btn w-100 phone-login text-center">
                    <span className="float-left login-icon">
                    <img className="" src={require('../assets/images/phone_icon.svg').default} />
                    </span>
                    <span className="text-white my-1">Phone</span>
                    <span className="login-icon float-right"></span>
                  </a>
                </div>
              )}

              {(window.location.hostname.includes("dev.ikara.co") || window.location.hostname.includes("test.ikara.co") || window.location.hostname.includes("localhost")) && (
                <div className="p-1">
                  {!this.state.showUidForm ? (
                    <button
                      type="button"
                      onClick={this.handleShowUidForm}
                      className="btn w-100 text-center"
                      style={{ backgroundColor: "#ee4242", color: "white" }}>
                      <span className="text-white my-1">Login with UID</span>
                    </button>
                  ) : (
                    <form onSubmit={this.handleUidLogin}>
                      <div className="mb-2">
                        <input
                          type="text"
                          className="form-control"
                          placeholder="UID"
                          value={this.state.uid}
                          onChange={this.handleUidChange}
                          style={{ marginBottom: "8px" }}
                        />
                        <input
                          type="password"
                          className="form-control"
                          placeholder="Password"
                          value={this.state.password}
                          onChange={this.handlePasswordChange}
                        />
                      </div>
                      <button
                        type="submit"
                        className="btn w-100 text-center mb-2"
                        style={{ backgroundColor: "#ee4242", color: "white" }}>
                        <span className="text-white my-1">Login with UID</span>
                      </button>
                      <button
                        type="button"
                        onClick={this.handleBack}
                        className="btn w-100 text-center"
                        style={{ backgroundColor: "#6c757d", color: "white" }}>
                        <span className="text-white my-1">Back</span>
                      </button>
                    </form>
                  )}
                </div>
              )}

              {!isLockedLogin && (
                <div className="text-center mt-2 login-cancel"><span data-dismiss="modal"><strong>Cancel</strong></span></div>
              )}
            </div>
          </div>
        </div>
      </div>
    );
  }
}

LoginDialog.contextType = MyContext;
export default withRouter(withTranslation()(LoginDialog))